import { useClientTerminology } from '@/views/list/NetworkTerms';
import { Box } from '@mantine/core';

export function NoResultsForSelectedAnalysis() {
  const intl = useClientTerminology();

  return (
    <Box>
      {intl.formatMessage({
        id: 'list.noResultsForSelectedAnalysis',
      })}
    </Box>
  );
}
